var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 18.3334H3.75C3.4186 18.333 3.10087 18.2012 2.86654 17.9668C2.6322 17.7325 2.50038 17.4148 2.5 17.0834V2.08337C2.50038 1.75197 2.6322 1.43425 2.86654 1.19991C3.10087 0.965573 3.4186 0.833754 3.75 0.833374H11.25C11.5814 0.833754 11.8991 0.965573 12.1335 1.19991C12.3678 1.43425 12.4996 1.75197 12.5 2.08337V3.95837H11.25V2.08337H3.75V17.0834H11.25V15.2084H12.5V17.0834C12.4996 17.4148 12.3678 17.7325 12.1335 17.9668C11.8991 18.2012 11.5814 18.333 11.25 18.3334ZM15.1075 10.2084L12.8663 12.4496L13.75 13.3334L17.5 9.58337L13.75 5.83337L12.8663 6.71712L15.1075 8.95837H6.25V10.2084H15.1075Z",
    fill: "#E9EEF7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/LogOut.79258156593e2e30d3de5b32a82226c9.svg";
export { ForwardRef as ReactComponent };